import React, {Component} from "react";
import * as styled from './cart.styled';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {CartButton, CartContainer, cartItem, cartTotal} from "./cart.styled";
import {faCartShopping, faLoader, faTrash} from "@fortawesome/pro-duotone-svg-icons";
import {faMinus, faPlus, faXmark} from "@fortawesome/pro-solid-svg-icons";
import * as cartController from '../../controllers/cart';
import * as shopController from '../../controllers/shop';
import {updateCart} from "../../controllers/cart";
import $ from 'jquery';

class Cart extends Component {
    constructor() {
        super();
        this.container = React.createRef();
        this.state = {
            loaded: false,
            open: false,
            cart: null,
            loadingPaymentLink: false
        };
    }

    componentDidCatch(error, errorInfo) {
    }

    componentDidMount() {
        this.loadCart();
    }

    loadCart() {
        return new Promise((resolve) => {
            this.setState((state) => {return {...state, loaded: false};}, () => {
                cartController.loadCart().then((cart) => {
                    this.setState((state) => {return {...state, cart, loaded: true}});
                });
            });
        });
    }

    getCartItemCount() {
        if (!this.state.cart?.order?.line_items) return 0;
        let count = 0;
        this.state.cart.order.line_items.map((item) => {
            count += parseInt(item.quantity);
        });
        return count;
    }

    setOpen(open) {
        this.setState(
            (state) => {return {...state, open}},
            () => {
                if (open) {
                    this.loadCart();
                    $(this.container.current)
                        .animate(
                            {opacity: 1},
                            500);
                }
            });
    }

    close() {
        $(this.container.current)
            .animate(
                {opacity: 0},
                500,
                () => {
                    this.setOpen(false);
                });
    }

    isCartActive() {
        return this.state.loaded && this.props.products && this.state.cart && this.state.cart.order && (this.state.cart?.order?.line_items?.length || 0) > 0;
    }

    getVariation(variation_id) {
        for (let productData of this.props.products) {
            for (let variation of productData.product.item_data.variations) {
                if (variation.id === variation_id) {
                    return [productData, variation];
                }
            }
        }
    }

    getItemImage(productData, image_id) {
        for (let image of productData.images) {
            if (image.id === image_id) {
                return image.image_data.url;
            }
        }
    }

    getOptionName(productData, option_id, value_id) {
        for (let option of productData.options) {
            if (option.id === option_id) {
                for (let value of option.item_option_data.values) {
                    if (value.id === value_id) {
                        return [
                            option.item_option_data.display_name,
                            value.item_option_value_data.name
                        ];
                    }
                }
            }
        }
    }

    async checkout() {
        return new Promise((resolve) => {
            this.setState((state) => {
                return {...state, loadingPaymentLink: true};
            }, () => {
                shopController.getPaymentLink().then((paymentLink) => {
                    window.setTimeout(() => {
                        this.setState((state) => {
                            return {...state, loadingPaymentLink: false};
                        }, () => {
                            if (paymentLink) {
                                    window.location = paymentLink;
                            }
                            resolve();
                        });
                    }, 2000);
                });
            });

        });
    }

    async removeItem(index) {
        let items = this.state.cart.order.line_items;
        items.splice(index);
        this.updateCart(items);
    }

    async changeQty(index, modifier) {
        let qty = this.state.cart.order.line_items[index].quantity;
        qty = parseInt(qty) + modifier;
        if (isNaN(qty) || qty <= 0) qty = 1;
        let items = this.state.cart.order.line_items;
        items[index].quantity = qty;
        this.updateCart(items);
    }

    async updateCart(items) {
        let updateItems = [];
        for (let item of items) {
            updateItems.push({
                qty: parseInt(item.quantity),
                variation_id: item.catalog_object_id
            });
        }

        this.setState((state) => {return {...state, loaded: false};}, () => {
            cartController.updateCart(updateItems).then(() => {
                this.loadCart();
            })
        });
    }

    render() {
        return (
            <>
                {
                    this.state.open ?
                        <styled.CartContainer ref={this.container}>
                            <styled.CloseButton onClick={this.close.bind(this)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </styled.CloseButton>
                            <div style={{width: '100%'}}>
                                <div style={{textAlign: 'center'}}>
                                    <styled.title>
                                        Cart
                                    </styled.title>
                                </div>
                                {
                                    this.isCartActive() ?
                                        <>
                                            <div style={{padding: '1vw 2vw'}}>
                                                {
                                                    this.state.cart.order.line_items.map((item, index) => {
                                                        let [productData, variation] = this.getVariation(item.catalog_object_id);
                                                        return (
                                                            <styled.cartItem key={index}>
                                                                <div className={'itemImage'}>
                                                                    <img src={this.getItemImage(productData, productData.product.item_data.image_ids[0])} />
                                                                </div>
                                                                <div className={'itemDescription'}>
                                                                    <div className={'itemName'}>
                                                                        {item.name}
                                                                    </div>
                                                                    {
                                                                        variation.item_variation_data.item_option_values ?
                                                                            <div>
                                                                                {
                                                                                    variation.item_variation_data.item_option_values.map((option, index) => {
                                                                                        let [option_name, option_value] = this.getOptionName(productData, option.item_option_id, option.item_option_value_id);
                                                                                        return (
                                                                                            <div key={index}>
                                                                                                {option_name}: {option_value}
                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                                <div className={'itemQty'}>
                                                                    <div className={'itemQtyButton'}>
                                                                        <FontAwesomeIcon
                                                                            icon={faMinus}
                                                                            onClick={this.changeQty.bind(this, index, -1)}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <input
                                                                            type={"number"}
                                                                            style={{
                                                                                padding: '0.5em',
                                                                                width: '3em',
                                                                                textAlign: 'right'
                                                                            }}
                                                                            onChange={(e) => {this.changeQty(index, e.currentTarget.value)}}
                                                                            value={item.quantity}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    <div className={'itemQtyButton'}>
                                                                        <FontAwesomeIcon
                                                                            icon={faPlus}
                                                                            onClick={this.changeQty.bind(this, index, 1)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className={'itemPrice'}>
                                                                    <div>
                                                                        {(item.base_price_money.amount / 100).toFixed(2)} {item.base_price_money.currency}
                                                                    </div>
                                                                    <div>
                                                                        <button className={'trash'} onClick={this.removeItem.bind(this, index)}>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </styled.cartItem>
                                                        );
                                                    })
                                                }
                                            </div>
                                            <styled.cartTotal>
                                                <div className={'totalContainer'}>
                                                    <div>
                                                        Total:
                                                    </div>
                                                    <div>
                                                        {(this.state.cart.order.total_money.amount / 100).toFixed(2)} {this.state.cart.order.total_money.currency}
                                                    </div>
                                                </div>
                                            </styled.cartTotal>
                                            <styled.checkoutContainer>
                                                <styled.checkoutButton onClick={this.checkout.bind(this)} disable={this.state.loadingPaymentLink}>
                                                    {
                                                        this.state.loadingPaymentLink ?
                                                            <FontAwesomeIcon className={'checkoutLoadingIcon'} icon={faLoader} spin style={{"--fa-primary-color": "#ffffff", "--fa-secondary-color": "#ffffff",}} />
                                                            : null
                                                    }
                                                    Proceed to checkout
                                                </styled.checkoutButton>
                                            </styled.checkoutContainer>
                                        </>
                                    :
                                        this.state.loaded ?
                                            <div style={{textAlign: 'center'}}>
                                                Your shopping cart is empty
                                            </div>
                                            :
                                            <div style={{textAlign: 'center'}}>
                                                <FontAwesomeIcon className={'loadingIcon'} icon={faLoader} spin />
                                            </div>
                                }
                            </div>
                        </styled.CartContainer>
                        :
                        <styled.CartButton onClick={this.setOpen.bind(this, true)} disabled={!this.isCartActive()}>
                            <div>
                                {
                                    this.state.loaded ?
                                        <>
                                            {this.getCartItemCount()} items
                                        </>
                                        :
                                        <>
                                            <FontAwesomeIcon className={'cartLoadingIcon'} icon={faLoader} spin />
                                        </>
                                }

                            </div>
                            <div>
                                <FontAwesomeIcon icon={faCartShopping} />
                            </div>
                        </styled.CartButton>
                }
            </>
        );
    }
}

export default Cart;
